import _ from "lodash";

const featureOptionsMixin = {
    computed: {
        standardDiff() {
            let standards = null;
            if (_.isNil(this.baseTrim)) {
                standards = this.trim.standards;
            } else {
                standards = _.differenceBy(
                    this.trim.standards,
                    this.baseTrim.standards,
                    "value"
                );
            }

            const standardGroups = _.groupBy(standards, "header");
            const selectedStandards = [];
            for (let i = 0; i < 5; i++) {
                _.each(standardGroups, group => {
                    const selectedStandard = group.shift();
                    if (!_.isNil(selectedStandard)) {
                        selectedStandards.push(selectedStandard);
                    }
                });
            }

            return _.slice(selectedStandards, 0, 5);
        }
    }
};

export default featureOptionsMixin;
